import { getFetch } from '@legacy/utils/fetcher';
import { useQuery } from '@tanstack/react-query';
import { formatUrl } from '@legacy/utils/url';
import ITimeTracker from '@legacy/apis/types/timeTrackerAPI';
import { useGetServerTimeZoneId } from '@legacy/apis/indexAPI';
import { getHourAndMinFromTimeTrackerResult } from '@legacy/utils/time/timeTrackerTime';
import {
  TIME_TRACKER_MENU_URL_PATH,
  GET_TIME_TRACKER_MSW_STATUS_KEY,
  GET_TIME_TRACKER_KEY,
} from '../utils';

const getTimeTracker = (): Promise<ITimeTracker> =>
  getFetch({
    path: TIME_TRACKER_MENU_URL_PATH,
    key: GET_TIME_TRACKER_MSW_STATUS_KEY,
  });

const fifteenMin = 1000 * 60 * 15;

export const useGetTimeTracker = () => {
  const { data, ...restProps } = useQuery({
    queryKey: [GET_TIME_TRACKER_KEY],
    queryFn: getTimeTracker,
    refetchInterval: fifteenMin,
    refetchIntervalInBackground: true,
  });
  const { serverTimeZoneId } = useGetServerTimeZoneId();
  const { properties: timeTrackerData, actions: timeTrackerAction } =
    data || {};
  const stopPath = timeTrackerAction?.find(
    (action) => action.name === 'stop',
  )?.href;

  return {
    data,
    serverTimeZoneId,
    time: getHourAndMinFromTimeTrackerResult(data, serverTimeZoneId),
    stopPath: formatUrl(stopPath),
    details: timeTrackerData,
    ...restProps,
  };
};
